
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const UserName = props => {

  const inputs = {
    userName: null,
  }

  const setUserName = async () => {
    if( props.setUserName) props.setUserName( inputs.userName.value);
  };

  const enterHandler = async event => {
    if( event.key === 'Enter') await setUserName();
  };

  useEffect( _ => {
    ReactDOM.findDOMNode( inputs.userName).focus();
  }, [ inputs.userName ]);

  return (
    <div className={'form username'}>
      <label> UserName: </label>
      <input className={'form-control'} ref={ ref => inputs.userName = ref } onKeyDown={ enterHandler }/>
      <button className={'submit pull-right'} onClick={ setUserName } > Submit </button>
    </div>
  );
};

export default UserName;
